import { Dialog } from '@mui/material'
import React, { useEffect } from 'react'
import PhotoGallery from './GalleryComponent/PhotoGallery'
import VideoGallery from './GalleryComponent/VideoGallery'
import backButton from '../../../assets/images/icons/back-black-icon.svg'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { isEmpty } from 'lodash'
export default function GalleryView(props) {
  console.log('=============Gallery=======')
  console.log('videos', props.videosArray)
  console.log('images', props.images)

  const [value, setValue] = React.useState(
    !isEmpty(props.images) && isEmpty(props.videosArray) ? '2' : '1',
  )

  useEffect(() => {
    setValue(!isEmpty(props.images) && isEmpty(props.videosArray) ? '2' : '1')
  }, [props.images, props.videosArray])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <div
      style={{
        // padding: '16px 20px 32px 20px',
        position: 'relative',
      }}
    >
      <Dialog
        fullScreen
        open={props.openGallery}
        keepMounted
        hideBackdrop={true}
        // TransitionComponent={Transition}
        className="modal-width "
        PaperProps={{
          style: {
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
            padding: '48px 20px 48px 20px',
            // marginBottom: '24px',
          },
        }}
      >
        {/* <button onClick={props.handleGalleryViewClose}>close it</button> */}
        <div>
          <div
            style={{
              top: '0px',
              marginBottom: '10px',
              textAlign: 'left',
              color: 'var(--gray100)',
              display: 'flex',
              position: 'fixed',
              background: 'white',
              left: '5px',
              paddingTop: '10px',
              cursor: 'pointer',
            }}
            className="dynamic-width"
            onClick={() => {
              props.handleGalleryViewClose()
              // props.setisDetailMuted(props.isDetailMuted)
            }}
          >
            <img src={backButton} alt="back"></img>
            <p className="title2">Gallery</p>
          </div>
        </div>

        <div style={{ marginTop: '20px' }}>
          <Box
            sx={{
              width: '100%',
              typography: 'body1',
              marginTop: '50px',
              marginBottom: '15px',
            }}
          >
            <TabContext value={value}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  marginBottom: '30px',
                }}
              >
                <TabList
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: { background: 'var(--primaryTeal)' },
                  }}
                  aria-label="lab API tabs example"
                  variant="fullWidth"
                  style={{
                    top: '50px',
                    textAlign: 'left',
                    color: 'var(--gray100)',
                    display: 'flex',
                    position: 'fixed',
                    background: 'white',
                    left: '0px',
                    paddingTop: '10px',
                    cursor: 'pointer',
                    borderBottom: '2px solid var(--gray10)',
                  }}
                  className="dynamic-width"
                >
                  {!isEmpty(props.videosArray) && (
                    <Tab
                      label="Videos"
                      value="1"
                      className="tabs-label headline2"
                    />
                  )}

                  {!isEmpty(props.images) && (
                    <Tab
                      label="Photos"
                      value="2"
                      className="tabs-label headline2"
                    />
                  )}
                </TabList>
              </Box>

              <TabPanel
                value="1"
                style={{ padding: '0px', paddingTop: '30px' }}
              >
                <VideoGallery
                  videos={props.videosArray}
                  id={props.id}
                  tokenStr={props.tokenStr}
                  totalPages={props.totalVideosPages}
                  videoSlides={props.videoSlides}
                />
              </TabPanel>
              <TabPanel
                value="2"
                style={{ padding: '0px', paddingTop: '30px' }}
              >
                <PhotoGallery
                  images={props.images}
                  id={props.id}
                  tokenStr={props.tokenStr}
                  totalPages={props.totalImagesPages}
                  imagesSlides={props.imagesSlides}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </Dialog>
    </div>
  )
}
